﻿export default function () {

    const querySelectorWithTemplate = function (selector) {
        let element = this.querySelector(selector);
        if (!element) {
            // loop through all template elements and find the first occurence of selector
            const templates = this.querySelectorAll("template");
            [...templates].every(template => {
                element = template.content.querySelectorWithTemplate(selector);
                return !element;
            });
        }

        return element;
    };

    const querySelectorAllWithTemplate = function (selector) {
        let elements = [...this.querySelectorAll(selector)];
        if (!elements.length) {
            // loop through all template elements and find all occurences of selector
            const templates = this.querySelectorAll("template");
            [...templates].every(template => {
                elements.push(...template.content.querySelectorAllWithTemplate(selector));
            });
        }
        return elements;
    };

    Document.prototype.querySelectorWithTemplate = querySelectorWithTemplate;
    DocumentFragment.prototype.querySelectorWithTemplate = querySelectorWithTemplate;
    Element.prototype.querySelectorWithTemplate = querySelectorWithTemplate
    Document.prototype.querySelectorAllWithTemplate = querySelectorAllWithTemplate;
    DocumentFragment.prototype.querySelectorAllWithTemplate = querySelectorAllWithTemplate
    Element.prototype.querySelectorAllWithTemplate = querySelectorAllWithTemplate;
}